export default __webpack_public_path__ + "static/media/MemberBlue.ee662584.svg";